import { FeatureFlag } from '@/global/plugins/firebase/types'
import { FeatureFlagValue } from './useGetFeatureFlag.types'

function resolveFeatureFlagValue(data?: FeatureFlag): FeatureFlagValue {
  if (!data || !data?.active) return false

  switch (data?.type) {
    case 'BOOLEAN': {
      const isString = typeof data?.value === 'string'
      const value = isString ? JSON.parse(data?.value) : data?.value

      return value
    }
    case 'INTEGER': {
      return Number(data?.value)
    }
    case 'DECIMAL': {
      return Number(data?.value).toFixed(2)
    }
    case 'STRING': {
      return data?.value
    }
    case 'DISTRIBUTION': {
      return data?.value
    }
    case 'HEXADECIMAL': {
      return data?.value
    }
    case 'LIST': {
      return data?.value.split(',')
    }
    default: {
      return data?.value
    }
  }
}

export { resolveFeatureFlagValue }
